import React, { useState, useEffect } from 'react';
import { useFrame } from '@react-three/fiber';
import styled from 'styled-components';

const FpsDisplay = styled.div`
  position: fixed;
  top: 10px;
  right: 10px;
  background-color: rgba(0, 0, 0, 0.5);
  color: ${props => props.fps < 30 ? '#ff4d4d' : props.fps < 50 ? '#ffff4d' : '#4dff4d'};
  font-family: monospace;
  font-size: 16px;
  padding: 6px 10px;
  border-radius: 4px;
  z-index: 1000;
  pointer-events: none;
`;

// Component to be used inside the Canvas
export function FpsMonitor() {
    // We use this to communicate with the DOM component outside Canvas
    if (typeof window !== 'undefined' && !window.__fpsCallback) {
        window.__fpsCallback = () => {};
    }

    // Track frame times
    const frameTimestamps = [];
    const maxSamples = 60;

    useFrame(() => {
        const now = performance.now();
        frameTimestamps.push(now);

        // Keep only the most recent samples
        while (frameTimestamps.length > maxSamples) {
            frameTimestamps.shift();
        }

        // Calculate FPS based on frame timestamps
        if (frameTimestamps.length > 1) {
            const timeElapsed = now - frameTimestamps[0];
            const frameCount = frameTimestamps.length - 1;
            const fps = Math.round((1000 * frameCount) / timeElapsed);

            // Send FPS to the DOM component
            if (typeof window !== 'undefined' && window.__fpsCallback) {
                window.__fpsCallback(fps);
            }
        }
    });

    // This doesn't render anything in 3D space
    return null;
}

// Component to be used outside the Canvas
export default function FpsCounter() {
    const [fps, setFps] = useState(0);

    useEffect(() => {
        // Set up the callback to receive FPS from the 3D component
        if (typeof window !== 'undefined') {
            window.__fpsCallback = setFps;
        }

        return () => {
            if (typeof window !== 'undefined') {
                window.__fpsCallback = () => {};
            }
        };
    }, []);

    return <FpsDisplay fps={fps}>FPS: {fps}</FpsDisplay>;
}
